import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/inventory" });

export const ToolService = {
  createTool: (payload) => api.post("/tools", payload),

  getTools: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/tools?${params.toString()}`);
  },

  getToolById: (id) => api.get(`/tools/${id}`),

  getToolActivity: (id, filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/tools/${id}/movement-history/?${params.toString()}`);
  },

  getToolInventory: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/tools-inventory?${params.toString()}`);
  },

  updateTool: (id, payload) => api.put(`/tools/${id}`, payload),

  deleteTool: (id) => api.delete(`/tools/${id}`),

  assignTool: (id, payload) => api.put(`/tools/${id}/move`, payload),

  incrementQuantity: (id, payload) => api.put(`/tools/${id}/increase`, payload),

  decrementQuantity: (id, payload) => api.put(`/tools/${id}/decrease`, payload),
};
